<button class="btn-back-to-top" (click)="scrollToTop()">
    <mat-icon>keyboard_arrow_up</mat-icon>
</button>